import { Skeleton } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { Resources, useResource } from "Translations/Resources";

export const MerchantNotesSkeleton = () => {
  const { t } = useResource();

  return (
    <FormSection
      legend={t(Resources.Hunter.Merchants.CompleteRegistration.Notes.Title)}
    >
      <Skeleton variant="rectangular" height={220} />
    </FormSection>
  );
};
